module.exports = __webpack_public_path__ + "img/testoutExplain.d03387cf.png";